import React, {Component} from "react";
import actions from '../actions';
import entityActions from '../../entities/actions';
import {connect} from 'react-redux';
import _ from '../../../baseApp/shared/utils/ObjectUtils';
import ObjectUtils from '../../shared/utils/ObjectUtils';
import TerminalsPage from "../components/TerminalsPage";

class TerminalsPageContainer extends Component {
    constructor() {
        super();
        this.state = {
            universalSearchField: "",
            defaultSort: {
                property : "lastCommunication",
                direction : "DESC"
            },
            searchFieldsValues: {
                terminalIdentifier: {
                    value: ""
                },
                name: {
                    value: ""
                },
                entityId: {
                    value: ""
                },
                terminalProfile: {
                    value: ""
                },
                status: {
                    value: ""
                }
            }
        }
    }

    componentDidMount() {
        const { getEntityList, getTerminalProfiles } = this.props;
        getEntityList();
        getTerminalProfiles();
        this.fetchData();
    }

    fetchData = (currentPage, pageSize, sortProperty, sortDirection) => {
        let {
            searchFieldsValues,
            universalSearchField,
            defaultSort
        } = this.state;

        if(currentPage === undefined){
            if(this.props.location.state?.searchFieldsData !== undefined){
                searchFieldsValues =  this.props.location.state.searchFieldsData;
                this.handleSearchFieldValuesChange(searchFieldsValues);
            }
            if(this.props.location.state?.universalSearchField !== undefined ){
                universalSearchField = this.props.location.state.universalSearchField;
                this.handleUniversalSearchFieldChange(universalSearchField);
            }
        }

        let filter = Object.entries(searchFieldsValues).reduce((acc, keyValuePair) => {
            return ObjectUtils.isNilOrEmpty(keyValuePair[1].value) ?
                {...acc} : {...acc, [keyValuePair[0]]: keyValuePair[1].value}
        }, {});

        if (!ObjectUtils.isNilOrEmpty(universalSearchField)) {
            filter = {
                ...filter,
                universalSearch: universalSearchField,
            }
        }

        this.props.searchTerminals({
            ...filter,
            currentPage: currentPage,
            pageSize: pageSize,
            sortProperty: !_.isNilOrEmpty(sortProperty) ? sortProperty : defaultSort.property,
            sortDirection: !_.isNilOrEmpty(sortDirection) ? sortDirection : defaultSort.direction,
        })
    };

    handleSearchFieldChange = (id, value) => {
        this.setState({
            searchFieldsValues: {
                ...this.state.searchFieldsValues,
                [id]: {
                    ...this.state.searchFieldsValues[id],
                    value: value
                }
            }
        })
    }

    handleSearchFieldValuesChange = (value) => {
        this.setState({
            searchFieldsValues: value
        })
    };

    handleUniversalSearchFieldChange = (value) => {
        this.setState({
            universalSearchField: value
        })
    }

    handleSearchSubmit = () => {
        const {
            table: {
                sort,
                pageNumber: currentPage,
                pageSize,
            }
        } = this.props;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    }

    handleSearchClear = () => {
        this.setState({
            universalSearchField: "",
            searchFieldsValues: Object.entries(this.state.searchFieldsValues)
                .reduce((acc, keyValuePair) => ({
                    ...acc,
                    [keyValuePair[0]]: {
                        ...keyValuePair[1],
                        value: ""
                    }
                }), {})
        })
    }

    onPageChange = (currentPage) => {
        const {
            table: {
                sort,
                pageSize,
                totalPages: pages
            }
        } = this.props;

        if (currentPage >= pages || currentPage < 0) return;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    }

    onPageSizeChange = (itemsPerPage) => {
        const {
            table: {
                sort,
                pageNumber: currentPage
            }
        } = this.props;

        this.fetchData(currentPage, itemsPerPage, sort.property, sort.direction);
    }

    handleSortChanged = newSort => {
        const {
            table:  {
                pageNumber,
                pageSize
            }
        } = this.props;

        const sortProperty = newSort[0].id;
        const sortDirection = newSort[0].desc? 'DESC' : 'ASC';

        this.fetchData(pageNumber, pageSize, sortProperty, sortDirection);
    }

    handleAddButtonClicked = () => {
        this.props.history.push('/terminals/create');
    }

    handleRowClicked = terminal => {
        this.props.history.push({
            pathname: '/terminals/' + terminal.id,
            state: { searchFieldsData : this.state.searchFieldsValues, universalSearchField: this.state.universalSearchField }
        });
    }

    render() {
        const { searchFieldsValues, universalSearchField } = this.state;
        const {
            table: {
                data,
                sort,
                pageSize,
                totalPages: pages,
                pageNumber: currentPage,
                totalElements
            },
            entityList,
            terminalProfilesList
        } = this.props;
        return (
            <TerminalsPage
                searchFieldsValues={searchFieldsValues}
                universalSearchField={universalSearchField}

                handleSearchFieldChange={this.handleSearchFieldChange}
                handleUniversalSearchFieldChange={this.handleUniversalSearchFieldChange}
                handleSearchSubmit={this.handleSearchSubmit}
                handleSearchClear={this.handleSearchClear}
                handleSortChanged={this.handleSortChanged}
                handleAddButtonClicked={this.handleAddButtonClicked}

                data={data}
                sort={sort}
                totalElements={totalElements}
                entityList={entityList}
                terminalProfilesList={terminalProfilesList}
                pages={pages}
                currentPage={currentPage}
                pageSize={pageSize}
                onRowClick={this.handleRowClicked}
                onPageChange={this.onPageChange}
                onPageSizeChange={this.onPageSizeChange}
            />
        );
    }
}

const mapStateToProps = ({ terminalsReducer, entitiesReducer }) => {
    return {
        searchFieldsData: terminalsReducer.searchFieldsData,
        table: terminalsReducer.table,
        entityList: entitiesReducer.entityList,
        terminalProfilesList: terminalsReducer.terminalProfilesList
    };
};

const mapDispatchToProps = {
    searchTerminals: actions.searchTerminals,
    getEntityList: entityActions.getEntityList,
    getTerminalProfiles: actions.getTerminalProfiles
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TerminalsPageContainer);